import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter()

    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const { id } = useParams();

    const path = '/projectdepartments/';
    const paths = {
        endpointSave: config.endpoints.backend + 'projects/save',
        endpointGetById: config.endpoints.backend + 'projects/getById',
        endpointGetExistProjectByCodes: config.endpoints.backend + 'projects/getExistProjectByCodes',
        endpointGetAllDepartments: config.endpoints.backend + 'entitydepartments/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Projeto",
        labelTitleEdit: "Editar Projeto",
        labelTitleView: 'Visualizar Projeto'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    readOnly: true
                },
                {
                    name: 'id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    readOnly: true
                },
                {
                    name: 'department_codes',
                    type: 'multiinput',
                    label: 'Departamentos',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Departamento',
                            type: 'select',
                            name: 'departmentid',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllDepartments,
                                label: 'department_name',
                                value: 'departmentid',
                                params: {
                                    filter: {
                                        pdc_entity_id: values.pdc_entity_id
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true,
                        unique_department: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                unique_department: async (value, options, key, attributes) => {
                    const checkUnique = async (value) => {
                        const post = {
                            codes: value,
                            pdc_project_id: id,
                            pdc_entity_id: values.pdc_entity_id
                        };

                        if (post.codes && post.codes.length > 0) {
                            const exists = await Fetch.post(paths.endpointGetExistProjectByCodes, post);
                            if (exists) {
                                return '^Algum dos códigos inseridos já pertence a outro projeto da entidade';
                            }
                        }

                        return "";
                    }
                    return checkUnique(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
